import { Card, ListLayout } from '@ingrid/luterkort-react';

import { LocalizedDate } from '~src/i18n/localized-date';
import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentDetails } from '../types';

interface Props {
  shipment: Pick<ShipmentDetails, 'created_at' | 'updated_at'>;
}

export function Details(props: Props) {
  const { shipment } = props;

  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.details')}</Card.Header>
      <Card.Content>
        <ListLayout.Column>
          <ListLayout.Stack>
            <ListLayout.Text variant="secondary">{t('common.createdAt')}</ListLayout.Text>
            <ListLayout.Text variant="primary">
              {shipment.created_at ? <LocalizedDate dateTime={shipment.created_at} time /> : '-'}
            </ListLayout.Text>
          </ListLayout.Stack>

          <ListLayout.Stack>
            <ListLayout.Text variant="secondary">{t('common.updatedAt')}</ListLayout.Text>
            <ListLayout.Text variant="primary">
              {shipment.updated_at ? <LocalizedDate dateTime={shipment.updated_at} time /> : '-'}
            </ListLayout.Text>
          </ListLayout.Stack>
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
